var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"page404"},[_vm._m(0),_c('el-button',{staticClass:"back",attrs:{"round":""},on:{"click":_vm.back}},[_vm._v("返回")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/bg/page404.png"),"alt":"404页面"}})])
}]

export { render, staticRenderFns }